module.exports = __webpack_public_path__ + "static/media/Momo.0fe0329e.jpg";